import React from 'react';
import ChevronRightIcon from '@moda/icons/chevron-right-16';
import { Clickable } from '@moda/om';
import { Link } from '../Link';
import { useNavItemHighlighting } from '../../hooks/useNavItemHighlighting';

import './MobileSiteNavOption.scss';

interface Props {
  arrow?: boolean;
  href?: string | null;
  title?: string;
  children: React.ReactNode;
  onClick?(): void;
}

export const MobileSiteNavOption: React.FC<Props> = ({ children, arrow, href, title, ...rest }) => {
  const { color } = useNavItemHighlighting(title || '');

  const props = {
    className: 'MobileSiteNavOption',
    style: { color },
    title,
    ...rest
  };

  const siteNameChildren = (
    <>
      <span className="MobileSiteNavOption__label">{children}</span>
      {arrow && <ChevronRightIcon />}
    </>
  );

  return href ? (
    <Link to={href} {...props}>
      {siteNameChildren}
    </Link>
  ) : (
    <Clickable {...props}>{siteNameChildren}</Clickable>
  );
};
